import React from 'react'
import { Helmet } from 'react-helmet'
import { Link } from 'react-router-dom'
import Navbar from '../components/navbar'
import Footer from '../components/footer'
import './not-found.css'

const NotFound = (props) => {
  return (
    <div className="not-found-container1">
      <Helmet>
        <title>404 - Seite nicht gefunden | Social Media Recruiting Agentur</title>
        <meta name="description" content="Die angeforderte Seite wurde nicht gefunden. Kehren Sie zur Startseite zurück." />
      </Helmet>
      <Navbar rootClassName="navbarroot-class-name"></Navbar>
      <div className="not-found-content">
        <h3>OOPS! SEITE NICHT GEFUNDEN</h3>
        <div className="not-found-container2">
          <h1 className="not-found-text2">404</h1>
        </div>
        <div className="not-found-container3">
          <h2 className="not-found-text3">
            Die angeforderte Seite wurde leider nicht gefunden.
          </h2>
        </div>
        <Link to="/" className="not-found-button">
          Zur Startseite
        </Link>
      </div>
      <Footer />
    </div>
  )
}

export default NotFound
